export const PROFICIENCY_THRESHOLDS = { GROWTH_OPPORTUNITIES: 60, PROFICIENCIES: 80 };

export const getProficiencyLabel = score => {
  if (score == null) return null;
  if (score >= PROFICIENCY_THRESHOLDS.PROFICIENCIES) return "Advanced";
  if (score >= PROFICIENCY_THRESHOLDS.GROWTH_OPPORTUNITIES) return "Intermediate";
  return "Foundational";
};

export const formatChartDate = dateString => {
  if (!dateString) return "";
  const d = new Date(dateString);
  return `${d.getMonth() + 1}.${d.getFullYear()}`;
};
